import React from "react";
import "./Footer.css";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="emk-footer">
      <div className="emk-footer-container">
        <div className="emk-footer-grid">
          {/* Column 1: Arklon Corporate Identity */}
          <div className="emk-footer-col profile-col">
            <div className="emk-footer-brand">
              <img
                src="/assets/Arklon logo.png"
                alt="Emmark Industries Logo"
                className="emk-footer-logo-img"
              />
            </div>
            <p className="emk-footer-brand-desc">
              <strong className="arklon-brand">Emmark Industries</strong> —
              Leading manufacturer of precision-engineered lap spools for
              textile and spinning industries since 1997.
            </p>
          </div>

          {/* Column 2: Quick Links Navigation */}
          <div className="emk-footer-col">
            <h5 className="emk-footer-title">
              Quick Links
            </h5>
            <ul className="emk-footer-links">
              <li>
                <a href="/">Home</a>
              </li>
              <li>
                <a href="/about">About Us</a>
              </li>
              <li>
                <a href="/products">Arklon Lap Spools</a>
              </li>
              <li>
                <a href="/contact">Contact Us</a>
              </li>
            </ul>
          </div>

          {/* Column 3: Arklon Lap Spool Products */}
          <div className="emk-footer-col">
            <h5 className="emk-footer-title">
              Lap Spools
            </h5>
            <ul className="emk-footer-links">
              <li>
                <a href="/products">Rieter E-36 Omega Lap Spools</a>
              </li>
              <li>
                <a href="/products">LMW</a>
              </li>
              <li>
                <a href="/products">Marzoli Lap Spools</a>
              </li>
              <li>
                <a href="/products">Trutzschler Lap Spools</a>
              </li>
              <li>
                <a href="/products">Cherry hara Lap Spools</a>
              </li>
              <li>
                <a href="/products">Vouk Lap Spools</a>
              </li>
            </ul>
          </div>

          {/* Column 4: Arklon Contact Information */}
          <div className="emk-footer-col">
            <h5 className="emk-footer-title">
              Contact
            </h5>
            <ul className="emk-footer-contact">
              <li>
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  className="emk-contact-icon"
                >
                  <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                  <circle cx="12" cy="10" r="3"></circle>
                </svg>
                <span>
                  Emmark Industries, A-10 Road, Kanjikode, Palakkad - 678 621,
                  Kerala, India
                </span>
              </li>
              <li>
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  className="emk-contact-icon"
                >
                  <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
                </svg>
                <a href="tel:+919495958871" className="emk-contact-link">
                  +91 9249535060
                  +91 9495958871
                </a>
              </li>
              <li>
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  className="emk-contact-icon"
                >
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                  <polyline points="22,6 12,13 2,6"></polyline>
                </svg>
                <a href="mailto:sales@emmark.in" className="emk-contact-link">
                  sales@emmark.in
                </a>
              </li>
              <li>
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  className="emk-contact-icon"
                >
                  <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
                  <line x1="9" y1="3" x2="9" y2="21"></line>
                  <line x1="15" y1="3" x2="15" y2="21"></line>
                  <line x1="3" y1="9" x2="21" y2="9"></line>
                  <line x1="3" y1="15" x2="21" y2="15"></line>
                </svg>
                <span className="emk-gst-tag">GST: 32AABFE4312L1ZU</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="emk-footer-divider"></div>

        {/* Footer Bottom - Arklon Copyright */}
        <div className="developed-by-inline">
          <p className="emk-copyright">
            © {currentYear} <a href="https://www.emmark.in" target="_blank" rel="noopener noreferrer">
              <strong className="arklon-brand">Emmark Industries</strong>
            </a>. All Rights Reserved.
          </p>
          <span className="separator">|</span>
          <div className="dev-info">
            <p className="emk-developed">
              Developed By <a href="https://www.mpeoples.in" target="_blank" rel="noopener noreferrer">
                <strong>MPeoples Business Solutions Pvt Ltd</strong>
              </a>
            </p>
          </div>
          {/* <span className="separator">|</span>
          <p className="emk-attribution">
            Precision Lap Spools for Global Textile Excellence
          </p> */}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
